export default "__VITE_ASSET__VgraguiX__"